
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Business } from '@/data/types/businessTypes';
import { LandingPagePreview } from './preview/LandingPagePreview';
import { GoogleAdPreview } from './preview/GoogleAdPreview';
import { LogoLayout } from './useLogoUpload';

interface PreviewSectionProps {
  business: Business;
  logoPreview: string | null;
  logoLayout: LogoLayout;
  previewTab: string;
  setPreviewTab: (tab: string) => void;
}

export const PreviewSection: React.FC<PreviewSectionProps> = ({
  business,
  logoPreview,
  logoLayout,
  previewTab,
  setPreviewTab
}) => {
  return (
    <div className="space-y-6">
      <div className="text-lg font-medium">Preview</div>
      
      <Tabs defaultValue="landing-page" value={previewTab} onValueChange={setPreviewTab}>
        <TabsList className="w-full">
          <TabsTrigger value="landing-page" className="flex-1">Landing Page</TabsTrigger>
          <TabsTrigger value="google-ad" className="flex-1">Google Ad</TabsTrigger>
        </TabsList>
        
        <div className="bg-gray-50 border rounded-md h-[300px] flex items-center justify-center p-4 mt-2 relative overflow-hidden">
          {previewTab === "landing-page" && (
            <LandingPagePreview 
              business={business} 
              logoPreview={logoPreview} 
              logoLayout={logoLayout}
            />
          )}
          
          {previewTab === "google-ad" && (
            <GoogleAdPreview 
              business={business} 
              logoPreview={logoPreview} 
              logoLayout={logoLayout}
            />
          )}
        </div>
      </Tabs>
      
      <div className="text-sm text-gray-600">
        See how your logo will appear in different contexts. A well-designed logo helps build brand recognition and trust.
      </div>
    </div>
  );
};
